import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as FavoriteMilitaryOccupationsFeatureState from './favorite-occupations.state';

export const selectFavoriteMilitaryOccupationState =
  createFeatureSelector<FavoriteMilitaryOccupationsFeatureState.FavoriteMilitaryOccupationsState>(
    FavoriteMilitaryOccupationsFeatureState.favoriteMilitaryOccupationsFeatureKey
  );

// RETRIEVE LIST OF OCCUPATIONS
export const selectFavoriteMilitaryOccupations = createSelector(
  selectFavoriteMilitaryOccupationState,
  (state) => state.favoriteMilitaryOccupations
);

// RETRIEVE FAVORITE OCCUPAIONS COUNT
export const selectFavoriteMilitaryOccupationCount = createSelector(
  selectFavoriteMilitaryOccupationState,
  (state) => state.favoriteMilitaryOccupations.length
);

export const selectIsOccupationInFavorites = (
  mocCode: string,
  mocTitle: string
) =>
  createSelector(selectFavoriteMilitaryOccupationState, (state) =>
    state.favoriteMilitaryOccupations.some(
      (e) => e.mocCode === mocCode && e.mocTitle === mocTitle
    )
  );

export const selectSimilarMilitaryOccupations = createSelector(
  selectFavoriteMilitaryOccupationState,
  (state) => state.similarMilitaryOccupations
);

export const selectMilitaryOccupationsForGoal = createSelector(
  selectFavoriteMilitaryOccupationState,
  (state) => state.militaryOccupationsForGoal
);
export const selectUserReclassifying = createSelector(
  selectFavoriteMilitaryOccupationState,
  (state) => state.userReclassifying
);

/** WALK-70 review. Whether the leaving-or-staying answer has been read. */
export const selectUserReclassifyingLoaded = createSelector(
  selectFavoriteMilitaryOccupationState,
  (state) => !!state.userReclassifyingLoaded
);
